import React from "react";
import {observer} from "mobx-react";
import {IVideoPlayerViewModel} from "../../../services/video/models/video-player.view-model.interface";
import {VideoWatchTimeLimitReachedBox} from "./boxes/video-watch-time-limit-reached.box";
import {useServices} from "../../../react-hooks/use-services.hook";

interface VideoWatchTimeLimitReachedComponentProps {
    videoPlayer: IVideoPlayerViewModel;
}
export const VideoWatchTimeLimitReachedComponent: React.FC<VideoWatchTimeLimitReachedComponentProps> = observer((props) => {
    const services = useServices();

    if(!props.videoPlayer.watchTimeLimitReached) {
        return null;
    }

    return (
        <VideoWatchTimeLimitReachedBox>
            {services.translation.translate('LIVE_STREAM_WATCH_TIME_REACHED')}
        </VideoWatchTimeLimitReachedBox>
    )
})